import { combineReducers } from "redux";
import AllReducers from "../action";

const rootReducer = combineReducers({ ...AllReducers });
export default rootReducer;
